import { Link } from 'react-router-dom';

/**
 * Dedicated 404 page for unmatched routes.
 *
 * Previously an unknown route silently became `<Navigate to="/" replace />`
 * with no feedback -- a user who mistyped a URL or followed a stale bookmark
 * got bounced with no explanation. See Issue 5 in
 * plan-responsekit-2026-08-04-universal-error-page.md.
 *
 * Deliberately does NOT call reportError()/the telemetry pipeline -- a 404
 * is a user/link error, not an app error, and auto-reporting every mistyped
 * URL would spam the client-error-log pipeline with nothing actionable.
 */
export default function NotFoundPage() {
  return (
    <div style={{ padding: 40, textAlign: 'center', fontFamily: 'sans-serif' }}>
      <p style={{ fontSize: 48, marginBottom: 8, fontWeight: 300, opacity: 0.5 }}>404</p>
      <p style={{ fontSize: 16, marginBottom: 16 }}>
        This page doesn't exist.
      </p>
      <Link to="/" className="btn-primary" style={{ display: 'inline-block', padding: '8px 20px', fontSize: 14, textDecoration: 'none' }}>
        Go home
      </Link>
    </div>
  );
}
